module.exports = __webpack_public_path__ + "assets/img/00181.988f4441.png";